(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/store/pd-preferences-slice.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/store/pd-preferences-slice.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _svs$myProfile$consta = svs.myProfile.constants.thunkStatus,
  FULFILLED = _svs$myProfile$consta.FULFILLED,
  REJECTED = _svs$myProfile$consta.REJECTED;
const logger = svs.myProfile.logger;
const _svs$myProfile$react$ = svs.myProfile.react.pages.myInformation.myInformationService,
  getCustomersPreferencesAsync = _svs$myProfile$react$.getCustomersPreferencesAsync,
  postConfirmMobileNumberAsync = _svs$myProfile$react$.postConfirmMobileNumberAsync,
  postEmailAsync = _svs$myProfile$react$.postEmailAsync,
  postCellPhoneAsync = _svs$myProfile$react$.postCellPhoneAsync,
  deleteCellPhoneAsync = _svs$myProfile$react$.deleteCellPhoneAsync;
const getCustomersPreferences = RTK.createAsyncThunk('playerdetails/getpreferences', async (_, _ref) => {
  let rejectWithValue = _ref.rejectWithValue,
    getState = _ref.getState;
  const playerPreferencesStatus = getState().playerPreferences.playerPreferencesStatus.status;
  const existingPlayerPreferences = getState().playerPreferences.playerPreferences;
  if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    return rejectWithValue({
      error: null
    });
  }
  if (playerPreferencesStatus !== 'initial' && existingPlayerPreferences.cid) {
    return existingPlayerPreferences;
  }
  try {
    const _await$getCustomersPr = await getCustomersPreferencesAsync(),
      playerPreferences = _await$getCustomersPr.playerPreferences,
      error = _await$getCustomersPr.error;
    if (error) {
      logger.warn('Error in get preferences...', error);
      return rejectWithValue({
        error
      });
    }
    return playerPreferences;
  } catch (error) {
    logger.warn('Error in get preferences...', error);
    return rejectWithValue({
      error
    });
  }
});
const postConfirmMobileNumber = RTK.createAsyncThunk('playerdetails/postconfirmmobilenumber', async (code, _ref2) => {
  let rejectWithValue = _ref2.rejectWithValue;
  try {
    var _svs$accountservices;
    const _await$postConfirmMob = await postConfirmMobileNumberAsync(code),
      error = _await$postConfirmMob.error;
    if (error !== null) {
      return rejectWithValue({
        error: error.code
      });
    }
    (_svs$accountservices = svs.accountservices) === null || _svs$accountservices === void 0 || (_svs$accountservices = _svs$accountservices.player_notifications_checker) === null || _svs$accountservices === void 0 || (_svs$accountservices = _svs$accountservices.events) === null || _svs$accountservices === void 0 || _svs$accountservices.trigger('clear');
    return {
      error: null
    };
  } catch (error) {
    logger.warn('Error in post confirm mobile number...', error);
    return rejectWithValue({
      error
    });
  }
});
const saveEmail = RTK.createAsyncThunk('playerdetails/saveemail', async (email, _ref3) => {
  let rejectWithValue = _ref3.rejectWithValue;
  try {
    var _svs$accountservices2;
    const _await$postEmailAsync = await postEmailAsync(email),
      error = _await$postEmailAsync.error;
    if (error !== null) {
      logger.debug('Error in post save email...', error);
      return rejectWithValue({
        error: error.code
      });
    }
    (_svs$accountservices2 = svs.accountservices) === null || _svs$accountservices2 === void 0 || (_svs$accountservices2 = _svs$accountservices2.player_notifications_checker) === null || _svs$accountservices2 === void 0 || (_svs$accountservices2 = _svs$accountservices2.events) === null || _svs$accountservices2 === void 0 || _svs$accountservices2.trigger('clear');
    return {
      error: null,
      email
    };
  } catch (error) {
    logger.debug('Error in post confirm email catch...', error);
    return rejectWithValue({
      error
    });
  }
});
const saveCellPhone = RTK.createAsyncThunk('playerdetails/savecellphone', async (cellPhone, _ref4) => {
  let rejectWithValue = _ref4.rejectWithValue;
  try {
    var _svs$accountservices3;
    const _await$postCellPhoneA = await postCellPhoneAsync(cellPhone),
      error = _await$postCellPhoneA.error;
    if (error !== null) {
      logger.debug('Error in post save cellphone...', error);
      return rejectWithValue({
        error: error.code
      });
    }
    (_svs$accountservices3 = svs.accountservices) === null || _svs$accountservices3 === void 0 || (_svs$accountservices3 = _svs$accountservices3.player_notifications_checker) === null || _svs$accountservices3 === void 0 || (_svs$accountservices3 = _svs$accountservices3.events) === null || _svs$accountservices3 === void 0 || _svs$accountservices3.trigger('clear');
    return {
      error: null,
      cellPhone
    };
  } catch (error) {
    logger.warn('Error in post save cellphone catch...', error);
    return rejectWithValue({
      error
    });
  }
});
const deleteCellPhone = RTK.createAsyncThunk('playerdetails/deletecellphone', async (cellPhone, _ref5) => {
  let rejectWithValue = _ref5.rejectWithValue;
  try {
    var _svs$accountservices4;
    const _await$deleteCellPhon = await deleteCellPhoneAsync(cellPhone),
      error = _await$deleteCellPhon.error;
    if (error !== null) {
      logger.warn('Error in delete cellPhone', error);
      return rejectWithValue({
        error: error.code
      });
    }
    (_svs$accountservices4 = svs.accountservices) === null || _svs$accountservices4 === void 0 || (_svs$accountservices4 = _svs$accountservices4.player_notifications_checker) === null || _svs$accountservices4 === void 0 || (_svs$accountservices4 = _svs$accountservices4.events) === null || _svs$accountservices4 === void 0 || _svs$accountservices4.trigger('clear');
    return {
      error: null
    };
  } catch (error) {
    logger.warn('Error in delete cellPhone catch...', error);
    return rejectWithValue({
      error
    });
  }
});
const pdPrefSlice = RTK.createSlice({
  name: 'pdpreferences',
  initialState: {
    playerPreferences: {},
    playerPreferencesStatus: {
      status: 'initial'
    },
    isPreferenceDataLoaded: false,
    isForceSaveMobile: false,
    isForceSaveEmail: false
  },
  reducers: {
    setForceSaveEmail: (state, action) => {
      state.isForceSaveEmail = action.payload;
    },
    setForceSaveMobile: (state, action) => {
      state.isForceSaveMobile = action.payload;
    },
    setVerifyEmail: state => {
      state.playerPreferences = _objectSpread(_objectSpread({}, state.playerPreferences), {
        emailStatus: '2'
      });
    }
  },
  extraReducers(builder) {
    builder.addCase(saveEmail.fulfilled, (state, action) => {
      state.playerPreferences = _objectSpread(_objectSpread({}, state.playerPreferences), {
        email: action.payload.email,
        emailStatus: '3'
      });
    }).addCase(saveCellPhone.fulfilled, (state, action) => {
      state.playerPreferences = _objectSpread(_objectSpread({}, state.playerPreferences), {
        cellphone: action.payload.cellPhone,
        cellPhoneStatus: '3'
      });
    }).addCase(deleteCellPhone.fulfilled, state => {
      state.playerPreferences = _objectSpread(_objectSpread({}, state.playerPreferences), {
        cellphone: null,
        cellPhoneStatus: '0'
      });
    }).addCase(getCustomersPreferences.rejected, state => {
      state.playerPreferences = {};
      state.playerPreferencesStatus = {
        status: REJECTED,
        error: 'rejected'
      };
    }).addCase(getCustomersPreferences.fulfilled, (state, action) => {
      state.playerPreferences = action.payload;
      state.playerPreferencesStatus = {
        status: FULFILLED,
        error: null
      };
      state.isPreferenceDataLoaded = true;
    }).addCase(postConfirmMobileNumber.fulfilled, state => {
      state.playerPreferences = _objectSpread(_objectSpread({}, state.playerPreferences), {
        cellPhoneStatus: '2'
      });
    });
  }
});
svs.myProfile.react.store.pdPreferences.actions = _objectSpread({
  getCustomersPreferences,
  postConfirmMobileNumber,
  saveEmail,
  saveCellPhone,
  deleteCellPhone
}, pdPrefSlice.actions);
svs.myProfile.react.store.pdPreferences.reducer = pdPrefSlice.reducer;

 })(window);